<template>
	<Spoiler class="question">
		<template v-slot:button="{opened}">
			<div class="question__head">
				<p class="question__title">{{ props.title }}</p>
				<i class="question__icon" :class="{'question__icon--opened' : opened}">
					<Icon name="down" />
				</i>
			</div>
		</template>
		<template v-slot:body>
			<div class="question__body">
				<slot></slot>
			</div>
		</template>
	</Spoiler>
</template>
<script lang="ts" setup>
import "./Question.scss";
import Spoiler from "@/components/Spoiler/Spoiler.vue";
import Icon from "@/components/Icon/Icon.vue";

interface Props{
	title : string
}

let props = defineProps<Props>();

</script>